// extracted by mini-css-extract-plugin
export default {"containerStyle":"ForToday_containerStyle__Ewe-M"};